// src/components/PlanSelector.tsx
import { useState, forwardRef } from "react";
import StandaloneSignUpForm, { type StandaloneSignUpFormHandle } from "./StandaloneSignUpForm";
import NutshellModalDollarOff from "./NutshellModalDollarOff";
import InfoModal from "./InfoModal";
import InfoIcon from "./InfoIcon";
import "../index.css";
//import { asset } from "@/lib/assets";

interface PlanSelectorProps {
  onSignUpSuccess: (email: string) => void;
  onVerificationSuccess: () => void;
}

const PlanSelector = forwardRef<StandaloneSignUpFormHandle, PlanSelectorProps>(
  ({ onSignUpSuccess, onVerificationSuccess }, ref) => {
    const selectedPlan = "free" as const;
    const [isDollarOpen, setIsDollarOpen] = useState(false);
    const [signupStage, setSignupStage] = useState<'email' | 'verify' | 'password'>('email');
    const [paidInfoOpen, setPaidInfoOpen] = useState(false);

    return (
      <div style={{ width: "100%", padding: "8px 16px", boxSizing: "border-box" }}>
        {/* Brand-styled signup card — only visible on the email stage.
            verify/password stages keep their own layout below. */}
        {signupStage === 'email' && (
          <>
            <h2
              id="join-free-heading"
              style={{
                fontFamily: "'Fredoka', sans-serif",
                fontSize: 22,
                fontWeight: 600,
                color: "#1A1A1A",
                textAlign: "center",
                maxWidth: 400,
                margin: "0 auto 2px auto",
                lineHeight: 1.25,
              }}
            >


              See if Anyone&apos;s Crushhhing<br/>on You — For Free{" "}
              <button
                type="button"
                onClick={() => setPaidInfoOpen(true)}
                aria-label="How free and paid tiers work"
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "0 0 0 2px",
                  verticalAlign: "middle",
                  lineHeight: 1,
                }}
              >
                <InfoIcon size={17} />
              </button>
            </h2>
            {paidInfoOpen && (
              <InfoModal onClose={() => setPaidInfoOpen(false)}>
                <strong>Seeing how many people added you, and getting notified when someone new does, is always free.</strong>{" "}
                Nobody&apos;s identity shows unless you both match. A one-time payment of $7.95 unlocks matching for good, no subscription, no per-match fees, ever.
              </InfoModal>
            )}
          </>
        )}
                              <p style={{ fontFamily: "'Nunito', sans-serif", textAlign: "center", fontSize: 14, color: "#555", margin: "0 0 24px", lineHeight: 1.5 }}>
                                
                              Then find out who — unlock matching for $7.95.
                              </p>
        <div
          id="plan-card"
          aria-live="polite"
          style={{
            background: "#E8D4B8",
            border: "3px solid #1A1A1A",
            borderRadius: 20,
            boxShadow: "6px 6px 0px #1A1A1A",
            padding: "28px 24px",
            maxWidth: 400,
            margin: "8px auto",
            boxSizing: "border-box",
          }}
        >
          {signupStage !== 'email' && (
            <h2
              style={{
                fontFamily: "'Fredoka', sans-serif",
                fontSize: 24,
                fontWeight: 700,
                color: "#1A1A1A",
                textAlign: "center",
                marginBottom: 16,
                marginTop: 0,
              }}
            >
              {signupStage === 'verify' ? 'Email Verification' : 'Create Your Password'}
            </h2>
          )}

          {/* Sign up form with stage tracking */}
          <div className="signup-section">
            <StandaloneSignUpForm
              ref={ref}
              selectedPlan={selectedPlan}
              onSignUpSuccess={(email) => {
                setSignupStage('verify');
                onSignUpSuccess(email);
              }}
              onVerificationSuccess={() => {
                onVerificationSuccess();
              }}
              onStageChange={(stage) => setSignupStage(stage)}
            />
          </div>
        </div>

        <NutshellModalDollarOff isOpen={isDollarOpen} onClose={() => setIsDollarOpen(false)} />
      </div>
    );
  }
);

PlanSelector.displayName = 'PlanSelector';

export default PlanSelector;